import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FrontendService } from 'src/app/services/frontend.service';
import * as Global from 'src/app/global';
import { OwlOptions } from 'ngx-owl-carousel-o/public_api';
import { CustomService } from 'src/app/services/custom.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    Global = Global;
    environment=environment;
    newsletterForm: FormGroup;
    pageLoading: boolean = true;
    socialLinks: any[] = [];
    pageContent: any = null;
    how_it_works: any = null;
    highlights: any = null;
    organisational_associate_content: any = null;
    associations_content:any=null;
    service_content: any = null;
    ready_to_get_started: any = null;
    sliders: any[] = [];
    organisational_associates: any[] = [];
    services: any[] = [];
    why_choose_us: any[] = [];
    blogs: any[] = [];
    associations:any;
    carouselOptions: OwlOptions = {
        loop: true,
        mouseDrag: true,
        touchDrag: false,
        pullDrag: false,
        dots: true,
        nav: false,
        navSpeed: 700,
        autoplay: true,
        responsive: {
            0: {
                items: 1
            },
            400: {
                items: 1
            },
            740: {
                items: 1
            },
            940: {
                items: 1
            }
        },
    }

    carouselbannerslide: OwlOptions = {
        loop: true,
        mouseDrag: true,
        touchDrag: false,
        pullDrag: false,
        dots: false,
        nav: true,
        navSpeed: 700,
        autoplay: true,
        responsive: {
            0: {
                items: 1
            },
            400: {
                items: 1
            },
            740: {
                items: 1
            },
            940: {
                items: 1
            }
        },
    }

    carouselOptions2: OwlOptions = {
        loop: true,
        mouseDrag: true,
        touchDrag: false,
        pullDrag: false,
        dots: true,
        nav: false,
        navSpeed: 700,
        autoplay: true,
        responsive: {
            0: {
                items: 1
            },
            400: {
                items: 2
            },
            740: {
                items: 3
            },
            940: {
                items: 6
            }
        },
    }

    constructor(
        private formBuilder: FormBuilder,
        private frontendService: FrontendService,
        private toastr: ToastrService,
        private customService: CustomService,
        public authService: AuthService,
    ) {
        this.newsletterForm = formBuilder.group({
            name: [null, Validators.compose([Validators.required])],
            email: [null, Validators.compose([Validators.required, Validators.email])],
        });
    }

    async ngOnInit() {
        await this.loadCms()
    }

    loadCms({
        loading = <boolean>true
    } = {}) {
        return new Promise((resolve, reject) => {
            if (loading) this.pageLoading = true;
            this.frontendService.loadCms({
                type: 'home'
            }).subscribe(res => {
                const data = res?.data;
                if (res.status == 'success') {
                    this.pageContent = data?.content ?? null;
                    this.how_it_works = data?.how_it_works ?? null;
                    this.organisational_associates = data?.organisational_associates ?? null;
                    this.organisational_associate_content = data?.organisational_associate_content ?? null;
                    this.associations_content=data?.associations_content?.content ?? null;
                    this.service_content = data?.service_content ?? null;
                    this.highlights = data?.highlights ?? null;
                    this.socialLinks = data?.social_links ?? [];
                    this.sliders = data?.sliders ?? [];
                    this.services = data?.services ?? [];
                    this.why_choose_us = data?.why_choose_us ?? [];
                    this.blogs = data?.blogs ?? [];
                    this.ready_to_get_started = data?.ready_to_get_started ?? null;
                    this.associations=data?.associations ?? [];
                    this.services=this.services.map(x=>{
                    x.description=x.description.replace(/<\/?[^>]+(>|$)/g, '');
                    return x;
                    })

                    resolve(true)
                } else {
                    this.customService.abortError(500, res?.message);
                    resolve(false)
                }

                if (loading) this.pageLoading = false;
            }, err => {
                this.customService.abortError(500, Global.getServerErrorMessage(err));
                if (loading) this.pageLoading = false;
                resolve(false)
            })
        })
    }

    submit(event: any) {
        this.newsletterForm.markAllAsTouched();
        Global.scrollToQuery(".form-control.is-invalid");

        if (this.newsletterForm.valid) {
            event.target.classList.add('btn-loading');
            event.target.disabled = true;

            this.frontendService.newsletterSubmit({
                'name': this.newsletterForm.value.name ?? null,
                'email': this.newsletterForm.value.email ?? null,
            }).subscribe(res => {
                const data = res.data;
                if (res.status == 'success') {
                    this.toastr.success(res.message);
                    Global.resetForm(this.newsletterForm)
                } else if (res.status == 'val_error') {
                    this.toastr.error(Global.getValidationMessage(data?.errors ?? []));
                } else {
                    this.toastr.error(res.message);
                }

                event.target.classList.remove('btn-loading');
                event.target.disabled = false;
            }, err => {
                this.toastr.error(Global.getServerErrorMessage(err));

                event.target.classList.remove('btn-loading');
                event.target.disabled = false;
            });
        }
    }
}
